import { CommercialData } from '../../types/fieldResearch';

interface Props {
  data: CommercialData;
  onChange: (data: CommercialData) => void;
}

const inputCls =
  'w-full bg-[#1a1640] border border-white/15 text-white placeholder-white/30 rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-purple-500/60 focus:border-purple-500/60 transition';

const interestOptions: {
  value: CommercialData['interestLevel'];
  label: string;
  active: string;
}[] = [
  { value: 'baixo', label: '🔴 Baixo', active: 'bg-red-600/25 border-red-500/60 text-white' },
  { value: 'medio', label: '🟡 Médio', active: 'bg-yellow-600/25 border-yellow-500/60 text-white' },
  { value: 'alto', label: '🟢 Alto', active: 'bg-green-600/25 border-green-500/60 text-white' },
];

const statusOptions: { value: CommercialData['visitStatus']; label: string }[] = [
  { value: 'visitado', label: 'Visitado' },
  { value: 'interessado', label: 'Interessado' },
  { value: 'sem_interesse', label: 'Sem interesse' },
  { value: 'retornar_depois', label: 'Retornar depois' },
];

export default function CommercialSection({ data, onChange }: Props) {
  const set = <K extends keyof CommercialData>(field: K, value: CommercialData[K]) =>
    onChange({ ...data, [field]: value });

  return (
    <div className="space-y-5">
      <h2 className="text-sm font-bold text-white">Dados Comerciais</h2>

      {/* Interesse */}
      <div className="space-y-2">
        <label className="block text-xs font-semibold text-white/50 uppercase tracking-wider">
          Nível de interesse *
        </label>
        <div className="grid grid-cols-3 gap-2">
          {interestOptions.map((o) => (
            <button
              key={o.value}
              type="button"
              onClick={() => set('interestLevel', o.value)}
              className={`py-3 rounded-xl border text-sm font-medium transition-all active:scale-95 ${
                data.interestLevel === o.value
                  ? o.active
                  : 'bg-white/5 border-white/10 text-white/60 hover:bg-white/10'
              }`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>

      {/* Status da visita */}
      <div className="space-y-2">
        <label className="block text-xs font-semibold text-white/50 uppercase tracking-wider">
          Status da visita *
        </label>
        {statusOptions.map((o) => (
          <button
            key={o.value}
            type="button"
            onClick={() => set('visitStatus', o.value)}
            className={`w-full text-left px-4 py-3 rounded-xl border text-sm transition-all active:scale-95 ${
              data.visitStatus === o.value
                ? 'bg-purple-600/25 border-purple-500/60 text-white'
                : 'bg-white/5 border-white/10 text-white/60 hover:bg-white/10'
            }`}
          >
            <span
              className={`inline-block w-3.5 h-3.5 rounded-full border mr-2.5 align-middle transition-colors ${
                data.visitStatus === o.value
                  ? 'bg-purple-500 border-purple-400'
                  : 'border-white/30'
              }`}
            />
            {o.label}
          </button>
        ))}
      </div>

      {/* Próximo passo */}
      <div className="space-y-2">
        <label className="block text-xs font-semibold text-white/50 uppercase tracking-wider">
          Próximo passo
        </label>
        <input
          className={inputCls}
          value={data.nextStep}
          onChange={(e) => set('nextStep', e.target.value)}
          placeholder="Ex: Ligar na próxima semana, enviar proposta..."
        />
      </div>
    </div>
  );
}
